import { ExtendedControlBarController, ExternalControlBarController, ExternalControlBarProExtension, ExternalEditorDaemon as ExternalEditorDaemon$1, ExternalToolboxController, ExternalToolboxProExtension } from '@nocode-js/sequential-workflow-designer-pro';
import { useMemo } from 'react';
import { jsx } from 'react/jsx-runtime';
import { Presenter, RootEditorWrapperContext, StepEditorWrapperContext } from 'sequential-workflow-designer-react';

function useExtendedControlBarController(deps) {
    return useMemo(function () { return ExtendedControlBarController.create(); }, deps || []);
}

function useExternalControlBarController(deps) {
    return useMemo(function () { return ExternalControlBarController.create(); }, deps || []);
}

var ReactExternalControlBarProExtension = ExternalControlBarProExtension;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var editorClassName = 'sqd-external-editor-react';
var ExternalEditorDaemon = /** @class */ (function () {
    function ExternalEditorDaemon(daemon, rootRef) {
        this.daemon = daemon;
        this.rootRef = rootRef;
    }
    ExternalEditorDaemon.create = function (api, configuration) {
        var rootRef = { current: null };
        var daemon = ExternalEditorDaemon$1.create(api, {
            placeholder: configuration.placeholder,
            rootEditorProvider: function (definition, context, isReadonly) {
                return Presenter.render(editorClassName, rootRef, jsx(RootEditorWrapperContext, __assign({ definition: definition, context: context, isReadonly: isReadonly }, { children: configuration.rootEditor })));
            },
            stepEditorProvider: function (step, context, definition, isReadonly) {
                return Presenter.render(editorClassName, rootRef, jsx(StepEditorWrapperContext, __assign({ step: step, definition: definition, context: context, isReadonly: isReadonly }, { children: configuration.stepEditor })));
            }
        });
        return new ExternalEditorDaemon(daemon, rootRef);
    };
    ExternalEditorDaemon.prototype.destroy = function () {
        this.daemon.destroy();
        Presenter.tryDestroy(this.rootRef);
    };
    return ExternalEditorDaemon;
}());

var ExternalEditorDaemonExtension = /** @class */ (function () {
    function ExternalEditorDaemonExtension(configuration) {
        this.configuration = configuration;
    }
    ExternalEditorDaemonExtension.prototype.create = function (api) {
        return ExternalEditorDaemon.create(api, this.configuration);
    };
    return ExternalEditorDaemonExtension;
}());

var ReactExternalEditorProExtension = /** @class */ (function () {
    function ReactExternalEditorProExtension(configuration) {
        this.configuration = configuration;
        this.daemons = [new ExternalEditorDaemonExtension(this.configuration)];
    }
    ReactExternalEditorProExtension.create = function (configuration) {
        return new ReactExternalEditorProExtension(configuration);
    };
    return ReactExternalEditorProExtension;
}());

function useExternalToolboxController(deps) {
    return useMemo(function () { return ExternalToolboxController.create(); }, deps || []);
}

var ReactExternalToolboxProExtension = ExternalToolboxProExtension;

export { ReactExternalControlBarProExtension, ReactExternalEditorProExtension, ReactExternalToolboxProExtension, useExtendedControlBarController, useExternalControlBarController, useExternalToolboxController };
